import React, { useCallback, useMemo } from "react";
import { Table } from "antd";
import { ISortObj } from "../../../../Models/applicationModels";
import { IAgentsDetailsResp } from "../../agents.model";
import { getAgentsTableColumns } from "./agentsTable.columns";
import { handleAgentsTableSortChange } from "./agentsTable.sort.utils";
import styles from "./agentsTable.module.css";
import { SorterResult } from "antd/es/table/interface";

interface AgentsTableProps {
    data: IAgentsDetailsResp[];
    visibleColumns: string[] | null;
    sortRequest: ISortObj | null;
    onSortChange: (sortItem: ISortObj | null) => void;
    onCreateDownline: (userId: number) => void;
}

export const AgentsTable = ({
    data,
    visibleColumns,
    sortRequest,
    onSortChange,
    onCreateDownline,
}: AgentsTableProps) => {
    const columns = useMemo(
        () =>
            getAgentsTableColumns({
                visibleColumns: visibleColumns ?? [],
                sortRequest,
                onCreateDownline,
            }),
        [visibleColumns, sortRequest, onCreateDownline]
    );

    const handleTableSortChange = useCallback(
        (_pagination: unknown, _filters: unknown, sorter: unknown) => {
            handleAgentsTableSortChange(
                sorter as SorterResult<unknown> | SorterResult<unknown>[],
                onSortChange
            );
        },
        [onSortChange]
    );

    if (!visibleColumns) return null;

    return (
        <Table<IAgentsDetailsResp>
            className={styles.agentsTable}
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey={(row) => row.userId}
            rowClassName={(_, index) => (index % 2 === 0 ? styles.evenRowStyle : styles.oddRowStyle)}
            scroll={{
                x: "max-content",
                y: "calc(100vh - 300px)",
            }}
            onChange={handleTableSortChange}
        />
    );
};
